import { add } from './add.js';
import { endOf } from './endOf.js';
import { startOf } from './startOf.js';
export const now = () => Date.now();
// TODO: Tests (just need to mock Date.now)
now.add = (amount, addUnit) => add(Date.now(), amount, addUnit);
now.endOf = (endOfUnit) => endOf(new Date(), endOfUnit);
now.startOf = (startOfUnit) => startOf(new Date(), startOfUnit);
now.subtract = (amount, subtractUnit) => add(Date.now(), -1 * amount, subtractUnit);
//# sourceMappingURL=now.js.map